import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/land/Login.vue';
import PalletMonitor from './views/workbench/palletMonitor/index.vue';
import PalletMonitorDetail from './views/workbench/palletMonitor/detail.vue';

Vue.use(Router);

export default new Router({
    routes: [
        {
            path: '/land-login',
            name: 'land-login',
            component: Login
        },
        {
            path: '/land-home',
            name: 'land-home',
            component: () => import('./views/land/Home.vue'),
            meta: {
                title: '智慧产业链'
            }
        },
        {
            path: '/download',
            name: 'download',
            component: () => import('./views/DownLoad.vue'),
            meta: {
                title: '智慧产业链'
            }
        },
        {
            path: '/jsbridge',
            name: 'jsbridge',
            component: () => import('./views/test/jsbridge.vue'),
            meta: {
                title: 'jsbridge'
            }
        },
        {
            path: '/nodata',
            name: 'nodata',
            component: () => import('./views/Nodata.vue'),
            meta: {
                title: '暂无内容'
            }
        },
        {
            path: '/land-report',
            name: 'land-report',
            component: () => import('./views/land/report/list.vue'),
            meta: {
                title: '上报统计'
            }
        },
        {
            path: '/land-storage',
            name: 'land-storage',
            component: () => import('./views/land/storage/list.vue'),
            meta: {
                title: '入库数据列表'
            }
        },
        {
            path: '/storage-detail',
            name: 'storage-detail',
            component: () => import('./views/land/storage/detail.vue'),
            meta: {
                title: '入库数据详情'
            }
        },
        {
            path: '/purchase-home',
            name: 'purchase-home',
            component: () => import('./views/purchase/home.vue'),
            meta: {
                title: '采购项目跟踪'
            }
        },
        {
            path: '/purchase-follow',
            name: 'purchase-follow',
            component: () => import('./views/purchase/follow/list.vue'),
            meta: {
                keepAlive: true,
                title: '采购项目跟踪'
            }
        },
        {
            path: '/purchase-follow-detail',
            name: 'purchase-follow-detail',
            component: () => import('./views/purchase/follow/detail.vue'),
            meta: {
                title: '采购项目跟踪'
            }
        },
        {
            path: '/purchase-review',
            name: 'purchase-review',
            component: () => import('./views/purchase/workreview/list.vue'),
            meta: {
                keepAlive: true,
                title: '采购员工作检视'
            }
        },
        {
            path: '/purchase-review-detail',
            name: 'purchase-review-detail',
            component: () => import('./views/purchase/workreview/detail.vue'),
            meta: {
                title: '采购员工作检视'
            }
        },
        {
            path: '/stowage-delivery-list',
            name: 'stowage-delivery-list',
            component: () => import('./views/stowage/delivery/list.vue'),
            meta: {
                title: '出库记账单填报'
            }
        },
        {
            path: '/stowage-delivery-add',
            name: 'stowage-delivery-add',
            component: () => import('./views/stowage/delivery/add.vue'),
            meta: {
                title: '编辑出库记账单'
            }
        },
        {
            path: '/stowage-delivery-detail',
            name: 'stowage-delivery-detail',
            component: () => import('./views/stowage/delivery/detail.vue'),
            meta: {
                title: '出库记账单详情'
            }
        },
        {
            path: '/stowage-delivery-history',
            name: 'stowage-delivery-history',
            component: () => import('./views/stowage/delivery/history.vue'),
            meta: {
                keepAlive: true,
                title: '历史出库记账单'
            }
        },
        {
            path: '/register-protocol',
            name: 'register-protocol',
            component: () => import('./views/protocol/RegisterProtocol.vue'),
            meta: {
                title: '注册协议'
            }
        },
        {
            path: '/stowage-delivery-baling',
            name: 'stowage-delivery-baling',
            component: () => import('./views/stowage/delivery/baling.vue'),
            meta: {
                title: '打包费录入'
            }
        },
        {
            path: '/staff',
            name: 'staff',
            component: () => import('./views/staff/home.vue'),
            meta: {
                title: '员工管理'
            }
        },
        {
            path: '/staff-user-list',
            name: 'staff-user-list',
            component: () => import('./views/staff/user/list.vue'),
            meta: {
                title: '承包户管理',
                keepAlive: true
            }
        },
        {
            path: '/staff-user-detail',
            name: 'staff-user-detail',
            component: () => import('./views/staff/user/detail.vue'),
            meta: {
                title: '承包户详情'
            }
        },
        {
            path: '/staff-user-add',
            name: 'staff-user-add',
            component: () => import('./views/staff/user/add.vue'),
            meta: {
                title: '承包户入职'
            }
        },
        {
            path: '/staff-user-leave',
            name: 'staff-user-leave',
            component: () => import('./views/staff/user/leave.vue'),
            meta: {
                title: '承包户离职'
            }
        },
        {
            path: '/staff-user-transfer',
            name: 'staff-user-transfer',
            component: () => import('./views/staff/user/transfer.vue'),
            meta: {
                title: '承包户调岗'
            }
        },
        {
            path: '/staff-attendance-list',
            name: 'staff-attendance-list',
            component: () => import('./views/staff/attendance/list.vue'),
            meta: {
                title: '承包户出勤打卡'
            }
        },
        {
            path: '/staff-attendance-history',
            name: 'staff-attendance-history',
            component: () => import('./views/staff/attendance/history.vue'),
            meta: {
                title: '承包户出勤记录',
                keepAlive: true
            }
        },
        {
            path: '/staff-attendance-clockin',
            name: 'staff-attendance-clockin',
            component: () => import('./views/staff/attendance/clockIn.vue'),
            meta: {
                title: '承包户出勤打卡'
            }
        },
        {
            path: '/staff-attendance-detail',
            name: 'staff-attendance-detail',
            component: () => import('./views/staff/attendance/detail.vue'),
            meta: {
                title: '承包户出勤记录'
            }
        },
        {
            path: '/field-report-detail',
            name: 'field-report-detail',
            component: () => import('./views/field/report/detail.vue'),
            meta: {
                title: '基地详情'
            }
        },
        {
            path: '/field-report-home',
            name: 'field-report-home',
            component: () => import('./views/field/report/home.vue'),
            meta: {
                title: '首页'
            }
        },
        {
            path: '/field-report-list',
            name: 'field-report-list',
            component: () => import('./views/field/report/list.vue'),
            meta: {
                title: '蓝莓'
            }
        },
        {
            path: '/authorization',
            name: 'authorization',
            component: () => import('./views/Authorization.vue'),
            meta: {
                title: ''
            }
        },
        {
            path: '/auth-middleware',
            name: 'auth-middleware',
            component: () => import('./views/AuthMiddleware.vue'),
            meta: {
                title: ''
            }
        },
        {
            path: '/blueberry-stowage-home',
            name: 'blueberry-stowage-home',
            component: () => import('./views/blueberry/stowage/home.vue'),
            meta: {
                keepAlive: true,
                title: ''
            }
        },
        {
            path: '/blueberry-stowage-add',
            name: 'blueberry-stowage-add',
            component: () => import('./views/blueberry/stowage/add.vue'),
            meta: {
                title: ''
            }
        },
        // 产品经理包材审批
        {
            path: '/blueberry-manage-mat-approve',
            name: 'blueberry-manage-mat-approve',
            component: () => import('./views/blueberry/manageMatApproval/index.vue'),
            meta: {
                title: '产品经理包材审批'
            }
        },
        {
            path: '/stowage-picking-list',
            name: 'stowage-picking-list',
            component: () => import('./views/stowage/picking/list.vue'),
            meta: {
                title: '领料单填报'
            }
        },
        {
            path: '/stowage-picking-add',
            name: 'stowage-picking-add',
            component: () => import('./views/stowage/picking/add.vue'),
            meta: {
                title: '编辑领料单'
            }
        },
        {
            path: '/stowage-picking-detail',
            name: 'stowage-picking-detail',
            component: () => import('./views/stowage/picking/detail.vue'),
            meta: {
                title: '领料单详情'
            }
        },
        {
            path: '/stowage-picking-history',
            name: 'stowage-picking-history',
            component: () => import('./views/stowage/picking/history.vue'),
            meta: {
                keepAlive: true,
                title: '历史领料单'
            }
        },
        {
            path: '/blueberry-stowage-detail',
            name: 'blueberry-stowage-detail',
            component: () => import('./views/blueberry/stowage/detail.vue'),
            meta: {
                title: '销售出库单详情'
            }
        },
        {
            path: '/blueberry-stowage-sales',
            name: 'blueberry-stowage-sales',
            component: () => import('./views/blueberry/stowage/sales.vue'),
            meta: {
                title: ''
            }
        },
        {
            path: '/blueberry-sales-home',
            name: 'blueberry-sales-home',
            component: () => import('./views/blueberry/sales/home.vue'),
            meta: {
                title: '蓝莓销售订单管理'
            }
        },
        {
            path: '/blueberry-sales-input-list',
            name: 'blueberry-sales-input-list',
            component: () => import('./views/blueberry/sales/inputList.vue'),
            meta: {
                keepAlive: true,
                title: '蓝莓销售订单录入列表'
            }
        },
        {
            path: '/blueberry-sales-input',
            name: 'blueberry-sales-input',
            component: () => import('./views/blueberry/sales/input.vue'),
            meta: {
                title: '蓝莓销售订单录入'
            }
        },
        {
            path: '/blueberry-sales-detail',
            name: 'blueberry-sales-detail',
            component: () => import('./views/blueberry/sales/detail.vue'),
            meta: {
                title: '蓝莓销售订单详情'
            }
        },
        {
            path: '/blueberry-sales-audit-list',
            name: 'blueberry-sales-audit-list',
            component: () => import('./views/blueberry/sales/auditList.vue'),
            meta: {
                keepAlive: true,
                title: '蓝莓销售订单审核列表'
            }
        },
        {
            path: '/file-download',
            name: 'file-download',
            component: () => import('./views/test/FileDownload.vue'),
            meta: {
                title: '文件下载'
            }
        },
        {
            path: '/blueberry-report-home',
            name: 'blueberry-report-home',
            component: () => import('./views/blueberry/report/home.vue'),
            meta: {
                title: '蓝莓数据日报首页'
            }
        },
        {
            path: '/blueberry-report-io',
            name: 'blueberry-report-io',
            component: () => import('./views/blueberry/report/io.vue'),
            meta: {
                keepAlive: true,
                title: '蓝莓出入库日报'
            }
        },
        {
            path: '/blueberry-report-io-sub',
            name: 'blueberry-report-io-sub',
            component: () => import('./views/blueberry/report/ioSub.vue'),
            meta: {
                title: '蓝莓出入库日报'
            }
        },
        {
            path: '/blueberry-report-sales',
            name: 'blueberry-report-sales',
            component: () => import('./views/blueberry/report/sales.vue'),
            meta: {
                keepAlive: true,
                title: '蓝莓销售日报'
            }
        },
        {
            path: '/blueberry-report-sales-sub',
            name: 'blueberry-report-sales-sub',
            component: () => import('./views/blueberry/report/salesSub.vue'),
            meta: {
                title: '蓝莓销售日报'
            }
        },
        {
            path: '/blueberry-report-move',
            name: 'blueberry-report-move',
            component: () => import('./views/blueberry/report/move.vue'),
            meta: {
                keepAlive: true,
                title: '蓝莓代销移库日报'
            }
        },
        {
            path: '/blueberry-report-move-sub',
            name: 'blueberry-report-move-sub',
            component: () => import('./views/blueberry/report/moveSub.vue'),
            meta: {
                title: '蓝莓代销移库日报'
            }
        },
        {
            path: '/blueberry-report-debt',
            name: 'blueberry-report-debt',
            component: () => import('./views/blueberry/report/debt.vue'),
            meta: {
                title: '欠款日报'
            }
        },
        {
            path: '/blueberry-report-export',
            name: 'blueberry-report-export',
            component: () => import('./views/blueberry/report/export.vue'),
            meta: {
                title: '日报导出'
            }
        },
        {
            path: '/blueberry-scrapped',
            name: 'blueberry-scrapped',
            component: () => import('./views/blueberry/scrapped/list.vue'),
            meta: {
                title: '蓝莓果品报废管理',
                keepAlive: true
            }
        },
        {
            path: '/blueberry-scrapped-add',
            name: 'blueberry-scrapped-add',
            component: () => import('./views/blueberry/scrapped/add.vue'),
            meta: {
                title: '蓝莓果品报废申请'
            }
        },
        {
            path: '/blueberry-loss',
            name: 'blueberry-loss',
            component: () => import('./views/blueberry/loss/list.vue'),
            meta: {
                title: '蓝莓损耗出库管理',
                keepAlive: true
            }
        },
        {
            path: '/blueberry-loss-add',
            name: 'blueberry-loss-add',
            component: () => import('./views/blueberry/loss/add.vue'),
            meta: {
                title: '蓝莓损耗出库申请'
            }
        },
        {
            path: '/blueberry-reWork',
            name: 'blueberry-reWork',
            component: () => import('./views/blueberry/reWork/list.vue'),
            meta: {
                title: '蓝莓翻包出库管理',
                keepAlive: true
            }
        },
        {
            path: '/blueberry-reWork-add',
            name: 'blueberry-reWork-add',
            component: () => import('./views/blueberry/reWork/add.vue'),
            meta: {
                title: '蓝莓翻包出库申请'
            }
        },
        {
            path: '/blueberry-differential-approval',
            name: 'blueberry-differential-approval',
            component: () => import('./views/blueberry/differentialApproval/list.vue'),
            meta: {
                title: '蓝莓出库数量差异审批',
                keepAlive: true
            }
        },
        {
            path: '/blueberry-differential-approval-add',
            name: 'blueberry-differential-approval-add',
            component: () => import('./views/blueberry/differentialApproval/add.vue'),
            meta: {
                title: '蓝莓出库数量差异审批',
                keepAlive: true
            }
        },
        {
            path: '/chore-home',
            name: 'chore-home',
            component: () => import('./views/chore/home.vue'),
            meta: {
                title: '首页'
            }
        },
        {
            path: '/chore-people-list',
            name: 'chore-people-list',
            component: () => import('./views/chore/people/list.vue'),
            meta: {
                keepAlive: true,
                title: '长/短工列表'
            }
        },
        {
            path: '/chore-people-add',
            name: 'chore-people-add',
            component: () => import('./views/chore/people/add.vue'),
            meta: {
                title: '新增/编辑人员信息'
            }
        },
        {
            path: '/chore-people-addLongWorker',
            name: 'chore-people-addLongWorker',
            component: () => import('./views/chore/people/addLongWorker.vue'),
            meta: {
                title: '新增长工信息'
            }
        },
        {
            path: '/chore-clock-list',
            name: 'chore-clock-list',
            component: () => import('./views/chore/clock/list.vue'),
            meta: {
                keepAlive: true,
                title: '短工用工登记列表'
            }
        },
        {
            path: '/chore-clock-input',
            name: 'chore-clock-input',
            component: () => import('./views/chore/clock/input.vue'),
            meta: {
                title: '短工用工登记'
            }
        },
        {
            path: '/chore-clock-history',
            name: 'chore-clock-history',
            component: () => import('./views/chore/clock/history.vue'),
            meta: {
                title: '短工登记记录'
            }
        },
        {
            path: '/chore-clock-detail',
            name: 'chore-clock-detail',
            component: () => import('./views/chore/clock/detail.vue'),
            meta: {
                title: '短工登记明细'
            }
        },
        {
            path: '/ticket-plane',
            name: 'ticket-plane',
            component: () => import('./views/ticket/plane.vue'),
            meta: {
                title: '机票预定申请'
            }
        },
        {
            path: '/workbench-index',
            name: 'workbench-index',
            component: () => import('./views/workbench/index.vue'),
            meta: {
                title: '工作台'
            }
        },
        {
            path: '/workbench-drainage-list',
            name: 'workbench-drainage-list',
            component: () => import('./views/workbench/drainage/list.vue'),
            meta: {
                keepAlive: true,
                title: '进/排液记录'
            }
        },
        {
            path: '/workbench-drainage-input',
            name: 'workbench-drainage-input',
            component: () => import('./views/workbench/drainage/input.vue'),
            meta: {
                title: '进/排液录入'
            }
        },
        {
            path: '/workbench-drainage-report',
            name: 'workbench-drainage-report',
            component: () => import('./views/workbench/drainage/report.vue'),
            meta: {
                title: '进/排液数据报表'
            }
        },
        {
            path: '/warehouse-home',
            name: 'warehouse-home',
            component: () => import('./views/warehouse/home.vue'),
            meta: {
                title: '海南果品出入库和领料单分摊'
            }
        },
        {
            path: '/warehouse-rawFruit-list',
            name: 'warehouse-rawFruit-list',
            component: () => import('./views/warehouse/rawFruit/list.vue'),
            meta: {
                keepAlive: true,
                title: '原料果入库列表'
            }
        },
        {
            path: '/warehouse-rawFruit-input',
            name: 'warehouse-rawFruit-input',
            component: () => import('./views/warehouse/rawFruit/input.vue'),
            meta: {
                title: '原料果入库录入'
            }
        },
        {
            path: '/warehouse-productFruit-list',
            name: 'warehouse-productFruit-list',
            component: () => import('./views/warehouse/productFruit/list.vue'),
            meta: {
                keepAlive: true,
                title: '成品果出库列表'
            }
        },
        {
            path: '/warehouse-productFruit-input',
            name: 'warehouse-productFruit-input',
            component: () => import('./views/warehouse/productFruit/input.vue'),
            meta: {
                title: '成品果出库录入'
            }
        },
        {
            path: '/warehouse-productFruit-input2',
            name: 'warehouse-productFruit-input2',
            component: () => import('./views/warehouse/productFruit/input2.vue'),
            meta: {
                title: '成品果出库录入'
            }
        },
        {
            path: '/warehouse-productFruit-input3',
            name: 'warehouse-productFruit-input3',
            component: () => import('./views/warehouse/productFruit/input3.vue'),
            meta: {
                title: '成品果出库录入'
            }
        },
        {
            path: '/warehouse-picking-list',
            name: 'warehouse-picking-list',
            component: () => import('./views/warehouse/picking/list.vue'),
            meta: {
                keepAlive: true,
                title: '领料单列表'
            }
        },
        {
            path: '/warehouse-reports',
            name: 'warehouse-reports',
            component: () => import('./views/warehouse/reports/index.vue'),
            meta: {
                keepAlive: true,
                title: '销售报表'
            }
        },
        {
            path: '/warehouse-picking-input',
            name: 'warehouse-picking-input',
            component: () => import('./views/warehouse/picking/input.vue'),
            meta: {
                title: '领料单填报'
            }
        },
        {
            path: '/workbench-pickTeam-list',
            name: 'workbench-pickTeam-list',
            component: () => import('./views/workbench/pickTeam/list.vue'),
            meta: {
                keepAlive: true,
                title: '采收队列表'
            }
        },
        {
            path: '/workbench-pickTeam-detail',
            name: 'workbench-pickTeam-detail',
            component: () => import('./views/workbench/pickTeam/detail.vue'),
            meta: {
                title: '采收队录入'
            }
        },
        {
            path: '/workbench-daysoff-list',
            name: 'workbench-daysoff-list',
            component: () => import('./views/workbench/daysOff/daysOffApproveList.vue'),
            meta: {
                title: '休息天数审列表'
            }
        },
        {
            path: '/workbench-daysoff-detail',
            name: 'workbench-daysoff-detail',
            component: () => import('./views/workbench/daysOff/daysOffApproveDetail.vue'),
            meta: {
                title: '休息天数审详情'
            }
        },
        {
            path: '/workbench-adjust-salary-list',
            name: 'workbench-adjust-salary-list',
            component: () => import('./views/workbench/adjustSalary/adjustSalaryList.vue'),
            meta: {
                title: '调整薪资列表'
            }
        },
        {
            path: '/workbench-adjust-salary-detail',
            name: 'workbench-adjust-salary-detail',
            component: () => import('./views/workbench/adjustSalary/adjustSalaryDetail.vue'),
            meta: {
                title: '调整薪资详情'
            }
        },
        {
            path: '/workbench-pickGroup-list',
            name: 'workbench-pickGroup-list',
            component: () => import('./views/workbench/pickGroup/list.vue'),
            meta: {
                keepAlive: true,
                title: '采收组管理'
            }
        },
        {
            path: '/workbench-pickGroup-detail',
            name: 'workbench-pickGroup-detail',
            component: () => import('./views/workbench/pickGroup/detail.vue'),
            meta: {
                title: '新增采收组'
            }
        },
        {
            path: '/workbench-pickGroupMember-list',
            name: 'workbench-pickGroupMember-list',
            component: () => import('./views/workbench/pickGroupMember/list.vue'),
            meta: {
                keepAlive: true,
                title: '组员管理'
            }
        },
        {
            path: '/workbench-pickGroupMember-detail',
            name: 'workbench-pickGroupMember-detail',
            component: () => import('./views/workbench/pickGroupMember/detail.vue'),
            meta: {
                title: '新增组员'
            }
        },
        {
            path: '/workbench-send-list',
            name: 'workbench-send-list',
            component: () => import('./views/workbench/send/list.vue'),
            meta: {
                title: '送果单列表'
            }
        },
        {
            path: '/workbench-send-detail',
            name: 'workbench-send-detail',
            component: () => import('./views/workbench/send/detail.vue'),
            meta: {
                title: '送果单详情'
            }
        },
        {
            path: '/workbench-pickPeople-list',
            name: 'workbench-pickPeople-list',
            component: () => import('./views/workbench/pickPeople/list.vue'),
            meta: {
                keepAlive: true,
                title: '采收工列表'
            }
        },
        {
            path: '/workbench-pickPeople-detail',
            name: 'workbench-pickPeople-detail',
            component: () => import('./views/workbench/pickPeople/detail.vue'),
            meta: {
                title: '采收工录入'
            }
        },
        {
            path: '/workbench-fruitPack-list',
            name: 'workbench-fruitPack-list',
            component: () => import('./views/workbench/fruitPack/list.vue'),
            meta: {
                keepAlive: true,
                title: '包装缴库管理'
            }
        },
        {
            path: '/workbench-fruitPack-detail',
            name: 'workbench-fruitPack-detail',
            component: () => import('./views/workbench/fruitPack/detail.vue'),
            meta: {
                title: '包装缴库录入'
            }
        },
        {
            path: '/workbench-rawfruitIn-list',
            name: 'workbench-rawfruitIn-list',
            component: () => import('./views/workbench/rawfruitIn/list.vue'),
            meta: {
                title: '原果入库管理'
            }
        },
        {
            path: '/workbench-rawfruitIn-detail',
            name: 'workbench-rawfruitIn-detail',
            component: () => import('./views/workbench/rawfruitIn/detail.vue'),
            meta: {
                title: '原果入库数据录入'
            }
        },
        {
            path: '/workbench-productFruit-list',
            name: 'workbench-productFruit-list',
            component: () => import('./views/workbench/productFruit/list.vue'),
            meta: {
                title: '成品果入库'
            }
        },
        {
            path: '/workbench-pickTeam-account',
            name: 'workbench-pickTeam-account',
            component: () => import('./views/workbench/pickTeam/account.vue'),
            meta: {
                keepAlive: true,
                title: '采收队子帐号管理'
            }
        },
        {
            path: '/workbench-pickTeam-accountAdd',
            name: 'workbench-pickTeam-accountAdd',
            component: () => import('./views/workbench/pickTeam/accountAdd.vue'),
            meta: {
                title: '采收队子帐号添加'
            }
        },
        {
            path: '/workbench-productFruitQC-list',
            name: 'workbench-productFruitQC-list',
            component: () => import('./views/workbench/productFruitQC/list.vue'),
            meta: {
                keepAlive: true,
                title: '成品果质检列表'
            }
        },
        {
            path: '/workbench-productFruitQC-detail',
            name: 'workbench-productFruitQC-detail',
            component: () => import('./views/workbench/productFruitQC/detail.vue'),
            meta: {
                title: '成品果质检详情'
            }
        },
        {
            path: '/workbench-productFruitQC-history',
            name: 'workbench-productFruitQC-history',
            component: () => import('./views/workbench/productFruitQC/history.vue'),
            meta: {
                keepAlive: true,
                title: '成品果质检历史'
            }
        },
        {
            path: '/workbench-rawFruitCheck-list',
            name: 'workbench-rawFruitCheck-list',
            component: () => import('./views/workbench/rawFruitCheck/list.vue'),
            meta: {
                title: '鲜果品检列表',
                keepAlive: true
            }
        },
        {
            path: '/workbench-rawFruitCheck-detail',
            name: 'workbench-rawFruitCheck-detail',
            component: () => import('./views/workbench/rawFruitCheck/detail.vue'),
            meta: {
                title: '鲜果品检详情'
            }
        },
        {
            path: '/workbench-rawFruitCheck-history',
            name: 'workbench-rawFruitCheck-history',
            component: () => import('./views/workbench/rawFruitCheck/history.vue'),
            meta: {
                title: '鲜果品检历史记录',
                keepAlive: true
            }
        },
        {
            path: '/workbench-rawFruitQCFollow-list',
            name: 'workbench-rawFruitQCFollow-list',
            component: () => import('./views/workbench/rawFruitQCFollow/list.vue'),
            meta: {
                title: '鲜果追溯品检管理',
                keepAlive: true
            }
        },
        {
            path: '/workbench-rawFruitQCFollow-detail',
            name: 'workbench-rawFruitQCFollow-detail',
            component: () => import('./views/workbench/rawFruitQCFollow/detail.vue'),
            meta: {
                title: '鲜果追溯品检详情'
            }
        },
        {
            path: '/workbench-noPackFruit-detail',
            name: 'workbench-noPackFruit-detail',
            component: () => import('./views/workbench/noPackFruit/detail.vue'),
            meta: {
                title: '未包装原果上报'
            }
        },
        {
            path: '/workbench-rawFruitTake-list',
            name: 'workbench-rawFruitTake-list',
            component: () => import('./views/workbench/rawFruitTake/list.vue'),
            meta: {
                title: '原果交接单列表'
            }
        },
        {
            path: '/workbench-rawFruitTake-detail',
            name: 'workbench-rawFruitTake-detail',
            component: () => import('./views/workbench/rawFruitTake/detail.vue'),
            meta: {
                title: '原果交接单详情'
            }
        },
        {
            path: '/workbench-scan-list',
            name: 'workbench-scan-list',
            component: () => import('./views/workbench/scan/list.vue'),
            meta: {
                title: '扫码出库管理'
            }
        },
        {
            path: '/workbench-scan-scanlist',
            name: 'workbench-scan-scanlist',
            component: () => import('./views/workbench/scan/scanlist.vue'),
            meta: {
                title: '扫码出库新增'
            }
        },
        {
            path: '/workbench-scan-scandetail',
            name: 'workbench-scan-scandetail',
            component: () => import('./views/workbench/scan/scandetail.vue'),
            meta: {
                title: '扫码出库详情'
            }
        },
        {
            path: '/workbench-scan-retail',
            name: 'workbench-scan-retail',
            component: () => import('./views/workbench/scan/retail.vue'),
            meta: {
                title: '零售出库新增'
            }
        },
        {
            path: '/workbench-scan-fruitlist',
            name: 'workbench-scan-fruitlist',
            component: () => import('./views/workbench/scan/fruitlist.vue'),
            meta: {
                title: '散果出库新增'
            }
        },
        {
            path: '/workbench-scan-fruitdetail',
            name: 'workbench-scan-fruitdetail',
            component: () => import('./views/workbench/scan/fruitdetail.vue'),
            meta: {
                title: '散果出库查看'
            }
        },
        {
            path: '/chore-workStatistics-list',
            name: 'chore-workStatistics-list',
            component: () => import('./views/chore/workStatistics/list.vue'),
            meta: {
                title: '长工用工统计',
                keepAlive: true
            }
        },
        {
            path: '/chore-workStatistics-detail',
            name: 'chore-workStatistics-detail',
            component: () => import('./views/chore/workStatistics/detail.vue'),
            meta: {
                title: '长工用工统计详情'
            }
        },
        {
            path: '/workbench-pickReport-index',
            name: 'workbench-pickReport-index',
            component: () => import('./views/workbench/pickReport/index.vue'),
            meta: {
                title: '采收包装数据报表'
            }
        },
        {
            path: '/workbench-factoryQuality-list',
            name: 'workbench-factoryQuality-list',
            component: () => import('./views/workbench/factoryQuality/list.vue'),
            meta: {
                title: '抽检记录', //加工厂质检
                keepAlive: true
            }
        },
        {
            path: '/workbench-quality-inspection',
            name: 'workbench-quality-inspection',
            component: () => import('./views/workbench/factoryQuality/component/process.vue'),
            meta: {
                title: '质量巡检', //加工厂质检
                keepAlive: true
            }
        },
        {
            path: '/workbench-factoryQuality-rawFruit-Detail',
            name: 'workbench-factoryQuality-rawFruit-Detail',
            component: () => import('./views/workbench/factoryQuality/rawFruitDetail.vue'),
            meta: {
                title: '原果入库检'
            }
        },
        {
            path: '/workbench-factoryQuality-rawFruit-result',
            name: 'workbench-factoryQuality-rawFruit-result',
            component: () => import('./views/workbench/factoryQuality/rawFruitResult.vue'),
            meta: {
                title: '抽检结果' //原果入库检
            }
        },
        {
            path: '/workbench-factoryQuality-rawFruit-Level1',
            name: 'workbench-factoryQuality-rawFruit-Level1',
            component: () => import('./views/workbench/factoryQuality/rawFruitLevel1.vue'),
            meta: {
                title: '一级预冷检' //原果入库检
            }
        },
        {
            path: '/workbench-factoryQuality-wrap-detail',
            name: 'workbench-factoryQuality-wrap-detail',
            component: () => import('./views/workbench/factoryQuality/wrapDetail.vue'),
            meta: {
                title: '包装过程检'
            }
        },
        {
            path: '/workbench-factoryQuality-product-detail',
            name: 'workbench-factoryQuality-product-detail',
            component: () => import('./views/workbench/factoryQuality/productDetail.vue'),
            meta: {
                title: '成品入库检'
            }
        },
        {
            path: '/workbench-factoryQuality-product-level2',
            name: 'workbench-factoryQuality-product-level2',
            component: () => import('./views/workbench/factoryQuality/productLevel2.vue'),
            meta: {
                title: '二级预冷检' //成品入库检
            }
        },
        {
            path: '/workbench-factoryQuality-product-in-lib-detail',
            name: 'workbench-factoryQuality-product-in-lib-detail',
            component: () => import('./views/workbench/factoryQuality/productInLibDetail.vue'),
            meta: {
                title: '成品在库检'
            }
        },
        {
            path: '/workbench-factoryQuality-product-out-lib-detail',
            name: 'workbench-factoryQuality-product-out-lib-detail',
            component: () => import('./views/workbench/factoryQuality/productOutLibDetail.vue'),
            meta: {
                title: '成品出库检'
            }
        },
        {
            path: '/workbench-factoryQuality-product-out-lib-list',
            name: 'workbench-factoryQuality-product-out-lib-list',
            component: () => import('./views/workbench/factoryQuality/productOutLibList.vue'),
            meta: {
                title: '成品出库检列表',
                keepAlive: true
            }
        },
        //单个物料抽检
        {
            path: '/workbench-factoryQuality-product-out-check',
            name: 'workbench-factoryQuality-product-out-check',
            component: () => import('./views/workbench/factoryQuality/component/productOutCheck.vue'),
            meta: {
                title: '成品出库检'
            }
        },
        {
            path: '/blueberry-monitor-list',
            name: 'blueberry-monitor-list',
            component: () => import('./views/blueberry/monitor/list.vue'),
            meta: {
                title: '未入库原果统计',
                keepAlive: true
            }
        },
        {
            path: '/blueberry-monitor-detail',
            name: 'blueberry-monitor-detail',
            component: () => import('./views/blueberry/monitor/detail.vue'),
            meta: {
                title: '未入库原果统计'
            }
        },
        {
            path: '/pickSchedule-confirm-index',
            name: 'pickSchedule-confirm-index',
            component: () => import('./views/pickSchedule/confirm/index.vue'),
            meta: {
                title: '采摘确认单'
            }
        },
        {
            path: '/pickSchedule-predict-index',
            name: 'pickSchedule-predict-index',
            component: () => import('./views/pickSchedule/predict/index.vue'),
            meta: {
                title: '采摘预测'
            }
        },
        {
            path: '/blueberry-weigh-list',
            name: 'blueberry-weigh-list',
            component: () => import('./views/blueberry/weigh/list.vue'),
            meta: {
                title: '加工中心原果复称',
                keepAlive: true
            }
        },
        {
            path: '/blueberry-weigh-detail',
            name: 'blueberry-weigh-detail',
            component: () => import('./views/blueberry/weigh/detail.vue'),
            meta: {
                title: '加工中心原果复称'
            }
        },
        {
            path: '/pickReport-quantity',
            name: 'pickReport-quantity',
            component: () => import('./views/pickReport/quantity.vue'),
            meta: {
                title: '采摘成本及采摘量报表'
            }
        },
        {
            path: '/pickReport-index',
            name: 'pickReport-index',
            component: () => import('./views/pickReport/index.vue'),
            meta: {
                title: '采摘包装报表'
            }
        },
        {
            path: '/pickReport-quality',
            name: 'pickReport-quality',
            component: () => import('./views/pickReport/quality.vue'),
            meta: {
                title: '采摘质量表'
            }
        },
        {
            path: '/pickReport-pickEfficiencyRanking',
            name: 'pickReport-pickEfficiencyRanking',
            component: () => import('./views/pickReport/pickEfficiencyRanking.vue'),
            meta: {
                title: '采摘效率排名'
            }
        },
        {
            path: '/pickReport-redFruitRanking',
            name: 'pickReport-redFruitRanking',
            component: () => import('./views/pickReport/redFruitRanking.vue'),
            meta: {
                title: '红果率排名'
            }
        },
        {
            path: '/pickReport-SoftFruitRanking',
            name: 'pickReport-SoftFruitRanking',
            component: () => import('./views/pickReport/SoftFruitRanking.vue'),
            meta: {
                title: '软果率排名'
            }
        },
        {
            path: '/pickReport-tornFruitRanking',
            name: 'pickReport-tornFruitRanking',
            component: () => import('./views/pickReport/tornFruitRanking.vue'),
            meta: {
                title: '撕裂果排名'
            }
        },
        {
            path: '/workbench-redFruit-list',
            name: 'workbench-redFruit-list',
            component: () => import('./views/workbench/redFruit/list.vue'),
            meta: {
                title: '红果&撕裂果检测',
                keepAlive: true
            }
        },
        {
            path: '/workbench-redFruit-detail',
            name: 'workbench-redFruit-detail',
            component: () => import('./views/workbench/redFruit/detail.vue'),
            meta: {
                title: '红果&撕裂果检测'
            }
        },
        {
            path: '/pickReport-costRanking',
            name: '/pickReport-costRanking',
            component: () => import('./views/pickReport/costRanking.vue'),
            meta: {
                title: '采摘成本排名表'
            }
        },
        {
            path: '/pickReport-employmentGap',
            name: '/pickReport-employmentGap',
            component: () => import('./views/pickReport/employmentGap.vue'),
            meta: {
                title: '采摘用工缺口率表'
            }
        },
        {
            path: '/packReport-index',
            name: 'packReport-index',
            component: () => import('./views/packReport/index.vue'),
            meta: {
                title: '加工中心报表'
            }
        },
        {
            path: '/packReport-costs',
            name: 'packReport-costs',
            component: () => import('./views/packReport/costs.vue'),
            meta: {
                title: '包装工费报表'
            }
        },
        {
            path: '/packReport-inventoryWarning',
            name: 'packReport-inventoryWarning',
            component: () => import('./views/packReport/inventoryWarning.vue'),
            meta: {
                title: '成品库存预警'
            }
        },
        {
            path: '/packReport-loss',
            name: 'packReport-loss',
            component: () => import('./views/packReport/loss.vue'),
            meta: {
                title: '包装损耗报表'
            }
        },
        {
            path: '/packReport-duration',
            name: 'packReport-duration',
            component: () => import('./views/packReport/duration.vue'),
            meta: {
                title: '装车用时报表'
            }
        },
        {
            path: '/packReport-course',
            name: 'packReport-course',
            component: () => import('./views/packReport/course.vue'),
            meta: {
                title: '包装进度报表'
            }
        },
        {
            path: '/packReport-storageTime',
            name: 'packReport-storageTime',
            component: () => import('./views/packReport/storageTime.vue'),
            meta: {
                title: '成品库龄报表'
            }
        },
        {
            path: '/handoverReport-index',
            name: 'handoverReport-index',
            component: () => import('./views/handoverReport/index.vue'),
            meta: {
                title: '采后环节时效监控表',
                keepAlive: true
            }
        },
        {
            path: '/handoverReport-handoverReportDetail',
            name: 'handoverReport-handoverReportDetail',
            component: () => import('./views/handoverReport/handoverReportDetail.vue'),
            meta: {
                title: '采后环节时效监控表详情'
            }
        },
        {
            path: '/blueberry-source',
            name: '/blueberry-source',
            component: () => import('./views/blueberry/source.vue'),
            meta: {
                title: '蓝莓果品信息'
            }
        },
        {
            path: '/blueberry-palletno',
            name: '/blueberry-palletno',
            component: () => import('./views/blueberry/palletno.vue'),
            meta: {
                title: '蓝莓托盘码果品信息'
            }
        },
        {
            path: '/saleReport-index',
            name: 'saleReport-index',
            component: () => import('./views/saleReport/index.vue'),
            meta: {
                title: '销售报表'
            }
        },
        {
            path: '/saleArea-home',
            name: 'saleArea-home',
            component: () => import('./views/saleReport/region/home.vue'),
            meta: {
                title: '客户公司'
            }
        },
        {
            path: '/saleArea-quantity',
            name: 'saleArea-quantity',
            component: () => import('./views/saleReport/region/quantity.vue'),
            meta: {
                title: '销量-销售地区'
            }
        },
        {
            path: '/saleArea-arrears',
            name: 'saleArea-arrears',
            component: () => import('./views/saleReport/region/arrears.vue'),
            meta: {
                title: '欠款'
            }
        },
        {
            path: '/saleArea-arrearsDetail',
            name: 'saleArea-arrearsDetail',
            component: () => import('./views/saleReport/region/arrearsDetail.vue'),
            meta: {
                title: '欠款' //大区详情
            }
        },
        {
            path: '/saleArea-areaDetail',
            name: 'saleArea-areaDetail',
            component: () => import('./views/saleReport/region/areaDetail.vue'),
            meta: {
                title: '大区明细-销售地区'
            }
        },
        {
            path: '/saleArea-sevenNewDev',
            name: 'saleArea-sevenNewDev',
            component: () => import('./views/saleReport/region/sevenNewDev.vue'),
            meta: {
                title: '七天新客户开发'
            }
        },
        {
            path: '/saleArea-sevenDetail',
            name: 'saleArea-sevenDetail',
            component: () => import('./views/saleReport/region/sevenDetail.vue'),
            meta: {
                title: '七天新客户开发'
            }
        },
        {
            path: '/saleFarm-home',
            name: 'saleFarm-home',
            component: () => import('./views/saleReport/farm/home.vue'),
            meta: {
                title: '基地农场'
            }
        },
        {
            path: '/saleFarm-saleroom',
            name: 'saleFarm-saleroom',
            component: () => import('./views/saleReport/farm/saleroom.vue'),
            meta: {
                title: '基地农场销售额'
            }
        },
        {
            path: '/saleFarm-saleroomDetail',
            name: 'saleFarm-saleroomDetail',
            component: () => import('./views/saleReport/farm/saleroomDetail.vue'),
            meta: {
                title: '基地农场销售额-基地明细'
            }
        },
        {
            path: '/saleFarm-quantity',
            name: 'saleFarm-quantity',
            component: () => import('./views/saleReport/farm/quantity.vue'),
            meta: {
                title: '销量-基地农场'
            }
        },
        {
            path: '/saleFarm-quantityDetail',
            name: 'saleFarm-quantityDetail',
            component: () => import('./views/saleReport/farm/quantityDetail.vue'),
            meta: {
                title: '销量明细-基地农场'
            }
        },
        {
            path: '/saleFarm-price',
            name: 'saleFarm-price',
            component: () => import('./views/saleReport/farm/price.vue'),
            meta: {
                title: '基地农场-均价'
            }
        },
        {
            path: '/saleFarm-priceDetail',
            name: 'saleFarm-priceDetail',
            component: () => import('./views/saleReport/farm/priceDetail.vue'),
            meta: {
                title: '基地农场-均价详情'
            }
        },
        {
            path: '/maintenance-index',
            name: 'maintenance-index',
            component: () => import('./views/maintenance/index.vue'),
            meta: {
                title: '灌溉设备维护保养'
            }
        },
        {
            path: '/maintenance-deviceRecord',
            name: 'maintenance-deviceRecord',
            component: () => import('./views/maintenance/deviceRecord.vue'),
            meta: {
                title: '设备检查记录'
            }
        },
        {
            path: '/maintenance-deviceInfo',
            name: 'maintenance-deviceInfo',
            component: () => import('./views/maintenance/deviceInfo.vue'),
            meta: {
                title: '设备信息'
            }
        },
        {
            path: '/maintenance-repairSubmit',
            name: 'maintenance-repairSubmit',
            component: () => import('./views/maintenance/repairSubmit.vue'),
            meta: {
                title: '维修提交'
            }
        },
        {
            path: '/maintenance-inspectSubmit',
            name: 'maintenance-inspectSubmit',
            component: () => import('./views/maintenance/inspectSubmit.vue'),
            meta: {
                title: '检查提交'
            }
        },
        {
            path: '/maintenance-repairCondition',
            name: 'maintenance-repairCondition',
            component: () => import('./views/maintenance/repairCondition.vue'),
            meta: {
                title: '维修情况'
            }
        },
        {
            path: '/maintenance-upkeep',
            name: 'maintenance-upkeep',
            component: () => import('./views/maintenance/upkeep.vue'),
            meta: {
                title: '设备保养'
            }
        },
        {
            path: '/fruitInfo-view',
            name: 'fruitInfo-view',
            component: () => import('./views/blueberry/fruitInfo/index.vue'),
            meta: {
                title: '果品信息查询'
            }
        },
        {
            path: '/workbench-plantPatrol-newList',
            name: 'workbench-plantPatrol-newList',
            component: () => import('./views/workbench/plantPatrol/newList.vue'),
            meta: {
                title: '植保巡园',
                keepAlive: true
            }
        },
        {
            path: '/workbench-plantPatrol-list',
            name: 'workbench-plantPatrol-list',
            component: () => import('./views/workbench/plantPatrol/list.vue'),
            meta: {
                title: '植保巡园记录',
                keepAlive: true
            }
        },
        {
            path: '/workbench-plantMonitor-list',
            name: 'workbench-plantMonitor-list',
            component: () => import('./views/workbench/plantMonitor/list.vue'),
            meta: {
                title: '植株生命状态监控',
                keepAlive: true
            }
        },
        {
            path: '/workbench-plantMonitor-detail',
            name: 'workbench-plantMonitor-detail',
            component: () => import('./views/workbench/plantMonitor/detail.vue'),
            meta: {
                title: '植株生命状态监控'
            }
        },
        {
            path: '/workbench-plantPatrol-newDetail',
            name: 'workbench-plantPatrol-newDetail',
            component: () => import('./views/workbench/plantPatrol/newDetail.vue'),
            meta: {
                title: '植保巡园记录'
            }
        },
        {
            path: '/workbench-plantPatrol-detail',
            name: 'workbench-plantPatrol-detail',
            component: () => import('./views/workbench/plantPatrol/detail.vue'),
            meta: {
                title: '植保巡园记录'
            }
        },
        {
            path: '/workbench-insectPest-index',
            name: 'workbench-insectPest-index',
            component: () => import('./views/workbench/insectPest/index.vue'),
            meta: {
                title: '植保巡园虫害'
            }
        },
        {
            path: '/plant',
            name: 'plant',
            component: () => import('./views/plant/home.vue'),
            meta: {
                title: '植保巡园'
            }
        },
        {
            path: '/export-index',
            name: 'export-index',
            component: () => import('./views/saleReport/export/index.vue'),
            meta: {
                title: '数据导出'
            }
        },
        {
            path: '/warehouse-productFruit-storage', //海南火龙果成品果实时库存
            name: 'warehouse-productFruit-storage',
            component: () => import('./views/warehouse/productFruit/storage.vue'),
            meta: {
                title: '成品果实时库存'
            }
        },
        {
            path: '/warehouse-productFruit-flowingWater', //海南火龙果成品果实时库存
            name: 'warehouse-productFruit-flowingWater',
            component: () => import('./views/warehouse/productFruit/flowingWater.vue'),
            meta: {
                title: '流水信息'
            }
        },
        {
            path: '/staff-packer-list', //海南工人管理
            name: 'staff-packer-list',
            component: () => import('./views/staff/packer/list.vue'),
            meta: {
                title: '海南工人管理'
            }
        },
        {
            path: '/staff-packer-detail', //海南工人管理
            name: 'staff-packer-detail',
            component: () => import('./views/staff/packer/detail.vue'),
            meta: {
                title: '海南工人管理'
            }
        },
        {
            path: '/farmmanage-index',
            name: 'farmmanage-index',
            component: () => import('./views/farmmanage/index.vue'),
            meta: {
                title: '农场管理体系'
            }
        },
        {
            path: '/farmmanage-meetingsituation',
            name: 'farmmanage-meetingsituation',
            component: () => import('./views/farmmanage/meeting/MeetingSituation.vue'),
            meta: {
                title: '会议情况登记'
            }
        },
        {
            path: '/redirect',
            name: 'redirect',
            component: () => import('./views/Redirect.vue'),
            meta: {
                title: ''
            }
        },
        {
            path: '/workbench-palletPack-list',
            name: 'workbench-meetingsituation-list',
            component: () => import('./views/workbench/palletPack/list.vue'),
            meta: {
                title: '组托管理'
            }
        },
        {
            path: '/workbench-palletPack-detail',
            name: 'workbench-meetingsituation-detail',
            component: () => import('./views/workbench/palletPack/detail.vue'),
            meta: {
                title: '组托管理'
            }
        },
        {
            path: '/pdc-statistics',
            name: 'pdc-statistics',
            component: () => import('./views/pdc/statistics.vue'),
            meta: {
                title: '植保工艺单管理'
            }
        },
        {
            path: '/pdc-gyd',
            name: 'pdc-gyd',
            component: () => import('./views/pdc/gyd.vue'),
            meta: {
                title: '工艺单'
            }
        },
        {
            path: '/pdc-list',
            name: 'pdc-list',
            component: () => import('./views/pdc/list.vue'),
            meta: {
                title: '未出植保工艺单病虫害统计'
            }
        },
        {
            path: '/pdc-bug-detail',
            name: 'pdc-bug-detail',
            component: () => import('./views/pdc/bugDetail.vue'),
            meta: {
                title: '植保病虫害详情'
            }
        },
        {
            path: '/pdc-history-gyd',
            name: 'pdc-history-gyd',
            component: () => import('./views/pdc/historyGyd.vue'),
            meta: {
                title: '历史植保工艺单'
            }
        },
        {
            path: '/workorder-list',
            name: 'workorder-list',
            component: () => import('./views/workorder/list.vue'),
            meta: {
                title: '工单管理列表'
            }
        },
        {
            path: '/workorder-neworder',
            name: 'workorder-neworder',
            component: () => import('./views/workorder/neworder.vue'),
            meta: {
                title: '新建工单'
            }
        },
        {
            path: '/workorder-workEntry',
            name: 'workorder-workEntry',
            component: () => import('./views/workorder/workEntry.vue'),
            meta: {
                title: '用工登记'
            }
        },
        {
            path: '/workorder-workSave',
            name: 'workorder-workSave',
            component: () => import('./views/workorder/workSave.vue'),
            meta: {
                title: '提交用工'
            }
        },
        {
            path: '/workorder-workSubmit',
            name: 'workorder-workSubmit',
            component: () => import('./views/workorder/workSubmit.vue'),
            meta: {
                title: '提交工单'
            }
        },

        {
            path: '/workorder-groupMember-checkIn',
            name: 'workorder-groupMember-checkIn',
            component: () => import('./views/workorder/groupMember/checkIn.vue'),
            meta: {
                title: '组员签到管理'
            }
        },
        {
            path: '/workorder-groupMember-success',
            name: 'workorder-groupMember-success',
            component: () => import('./views/workorder/groupMember/success.vue'), //签到成功
            meta: {
                title: '组员签到管理'
            }
        },
        {
            path: '/workbench-scan-giftdetail',
            name: 'workbench-scan-giftdetail',
            component: () => import('./views/workbench/scan/giftdetail.vue'),
            meta: {
                title: '礼品出库'
            }
        },
        {
            path: '/workbench-scan-returndetail',
            name: 'workbench-scan-returndetail',
            component: () => import('./views/workbench/scan/returndetail.vue'),
            meta: {
                title: '生产退库'
            }
        },
        {
            path: '/workbench-preSeal-list',
            name: 'workbench-preSeal-list',
            component: () => import('./views/workbench/preSeal/list.vue'),
            meta: {
                title: '前置仓交接',
                keepAlive: true
            }
        },
        {
            path: '/workbench-preSeal-detail',
            name: 'workbench-preSeal-detail',
            component: () => import('./views/workbench/preSeal/detail.vue'),
            meta: {
                title: '中转托盘称重'
            }
        },
        {
            path: '/homepage-index',
            name: 'homepage-index',
            component: () => import('./views/homepage/index.vue'),
            meta: {
                title: '主页'
            }
        },
        {
            path: '/workbench-preYgAgainWeight-list',
            name: 'workbench-preYgAgainWeight-list',
            component: () => import('./views/workbench/preYgAgainWeight/list.vue'),
            meta: {
                title: '前置仓复称',
                keepAlive: true
            }
        },
        {
            path: '/workbench-preYgAgainWeight-detail',
            name: 'workbench-preYgAgainWeight-detail',
            component: () => import('./views/workbench/preYgAgainWeight/detail.vue'),
            meta: {
                title: '前置仓复称'
            }
        },
        {
            path: '/workbench-preYgAgainWeight-AgainWeight',
            name: 'workbench-preYgAgainWeight-AgainWeight',
            component: () => import('./views/workbench/preYgAgainWeight/AgainWeight.vue'),
            meta: {
                title: '前置仓复称'
            }
        },
        {
            path: '/unionsale-warehouseManagement-list',
            name: 'unionsale-warehouseManagement-list',
            component: () => import('./views/unionsale/warehouseManagement/list.vue'),
            meta: {
                title: '到货入库管理', //联合批发管理
                keepAlive: true
            }
        },
        {
            path: '/unionsale-warehouseManagement-newList',
            name: 'unionsale-warehouseManagement-newList',
            component: () => import('./views/unionsale/warehouseManagement/newList.vue'),
            meta: {
                title: '到货入库管理', //联合批发管理
                keepAlive: true
            }
        },
        {
            path: '/unionsale-warehouseManagement-detail',
            name: 'unionsale-warehouseManagement-detail',
            component: () => import('./views/unionsale/warehouseManagement/detail.vue'),
            meta: {
                title: '到货入库查看'
            }
        },
        {
            path: '/unionsale-warehouseManagement-confirm',
            name: 'unionsale-warehouseManagement-confirm',
            component: () => import('./views/unionsale/warehouseManagement/confirm.vue'),
            meta: {
                title: '到货入库确认'
            }
        },
        {
            path: '/unionsale-warehouseManagement-add',
            name: 'unionsale-warehouseManagement-add',
            component: () => import('./views/unionsale/warehouseManagement/add.vue'),
            meta: {
                title: '到货入库'
            }
        },
        {
            path: '/unionsale-priceRequest-list',
            name: 'unionsale-priceRequest-list',
            component: () => import('./views/unionsale/priceRequest/list.vue'),
            meta: {
                title: '价格申请列表',
                keepAlive: true
            }
        },
        {
            path: '/unionsale-priceRequest-detail',
            name: 'unionsale-priceRequest-detail',
            component: () => import('./views/unionsale/priceRequest/detail.vue'),
            meta: {
                title: '价格申请单'
            }
        },
        {
            path: '/unionsale-priceCompareTask-list',
            name: 'unionsale-priceCompareTask-list',
            component: () => import('./views/unionsale/priceCompareTask/list.vue'),
            meta: {
                title: '线上比价任务发布',
            }
        },
        {
            path: '/unionsale-priceCompareTask-add',
            name: 'unionsale-priceCompareTask-add',
            component: () => import('./views/unionsale/priceCompareTask/add.vue'),
            meta: {
                title: '新建线上比价任务'
            }
        },
        {
            path: '/unionsale-inventory-list',
            name: 'unionsale-inventory-list',
            component: () => import('./views/unionsale/inventory/list.vue'),
            meta: {
                title: '实时库存',
                keepAlive: true
            }
        },
        {
            path: '/unionsale-inventory-detail',
            name: 'unionsale-inventory-detail',
            component: () => import('./views/unionsale/inventory/detail.vue'),
            meta: {
                title: '收发明细表'
            }
        },
        {
            path: '/unionsale-arrivalInfo-list',
            name: 'unionsale-arrivalInfo-list',
            component: () => import('./views/unionsale/arrivalInfo/list.vue'),
            meta: {
                title: '到货信息查询',
                keepAlive: true
            }
        },
        {
            path: '/unionsale-arrivalInfo-detail',
            name: 'unionsale-arrivalInfo-detail',
            component: () => import('./views/unionsale/arrivalInfo/detail.vue'),
            meta: {
                title: '到货详情'
            }
        },
        {
            path: '/unionsale-arrivalInfo-scrap',
            name: 'unionsale-arrivalInfo-scrap',
            component: () => import('./views/unionsale/arrivalInfo/scrap.vue'),
            meta: {
                title: '报废详情'
            }
        },
        {
            path: '/temporaryWorker-leader-list',
            name: 'temporaryWorker-leader-list',
            component: () => import(/* webpackPrefetch: true */ './views/temporaryWorker/leader/employeeList.vue'),
            meta: {
                title: '临工管理'
            }
        },
        {
            path: '/temporaryWorker-leader-Information',
            name: 'temporaryWorker-leader-Information',
            component: () => import(/* webpackPrefetch: true */ './views/temporaryWorker/leader/Information.vue'),
            meta: {
                title: '信息录入'
            }
        },
        {
            path: '/temporaryWorker-employeeInfo',
            name: 'temporaryWorker-employeeInfo',
            component: () => import('./views/temporaryWorker/employeeInfo.vue'),
            meta: {
                title: '信息录入'
            }
        },
        {
            path: '/temporaryWorker-login',
            name: 'temporaryWorker-login',
            component: () => import('./views/temporaryWorker/login.vue'),
            meta: {
                title: '临工登录'
            }
        },
        {
            path: '/temporaryWorker-employeeLogin',
            name: 'temporaryWorker-employeeLogin',
            component: () => import('./views/temporaryWorker/employeeLogin.vue'),
            meta: {
                title: '临工登录'
            }
        },
        {
            path: '/temporaryWorker-password',
            name: 'temporaryWorker-password',
            component: () => import('./views/temporaryWorker/password.vue'),
            meta: {
                title: '临工修改密码'
            }
        },
        {
            path: '/temporaryWorker-mine',
            name: 'temporaryWorker-mine',
            component: () => import('./views/temporaryWorker/mine.vue'),
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/temporaryWorker-home',
            name: 'temporaryWorker-home',
            component: () => import('./views/temporaryWorker/home.vue'),
            meta: {
                title: '个人中心'
            }
        },
        {
            path: '/temporaryWorker-clock-list',
            name: 'temporaryWorker-clock-list',
            component: () => import('./views/temporaryWorker/clock/list.vue'),
            meta: {
                title: '考勤管理'
            }
        },
        {
            path: '/over-age',
            name: 'over-age',
            component: () => import('./views/temporaryWorker/message/overAge.vue'),
            meta: {
                title: '临工超龄提醒'
            }
        },
        {
            path: '/import-approval',
            name: 'import-approval',
            component: () => import('./views/temporaryWorker/message/importApproval.vue'),
            meta: {
                title: '用工统计超指导价'
            }
        },
        // {
        //     path: '/over-guide',
        //     name: 'over-guide',
        //     component: () => import('./views/temporaryWorker/message/overGuide.vue'),
        //     meta: {
        //         title: '超过指导定价详情'
        //     }
        // },
        {
            path: '/unionsale-market-out',
            name: 'unionsale-market-out',
            component: () => import('./views/unionsale/market/out.vue'),
            meta: {
                title: '销售出库'
            }
        },
        {
            path: '/clubsale-market-out',
            name: 'clubsale-market-out',
            component: () => import('./views/clubsale/market/out.vue'),
            meta: {
                title: '销售出库'
            }
        },
        {
            path: '/unionsale-home',
            name: 'unionsale-home',
            component: () => import('./views/unionsale/home.vue'),
            meta: {
                title: '联合销售管理'
            }
        },
        {
            path: '/unionsale-outbound-list',
            name: 'unionsale-outbound-list',
            component: () => import('./views/unionsale/outbound/list.vue'),
            meta: {
                title: '出库详情',
                keepAlive: true
            }
        },
        {
            path: '/unionsale-outbound-detail',
            name: 'unionsale-outbound-detail',
            component: () => import('./views/unionsale/outbound/detail.vue'),
            meta: {
                title: '果品出库明细'
            }
        },
        {
            path: '/unionsale-outbound-add',
            name: 'unionsale-outbound-add',
            component: () => import('./views/unionsale/outbound/add.vue'),
            meta: {
                title: '果品出库'
            }
        },
        {
            path: '/workbench-qualityCheck-list',
            name: 'workbench-qualityCheck-list',
            component: () => import('./views/workbench/qualityCheck/list.vue'),
            meta: {
                title: '抽检记录',
                keepAlive: true
            }
        },
        {
            path: '/workbench-qualityCheck-detail',
            name: 'workbench-qualityCheck-detail',
            component: () => import(/* webpackPrefetch: true */ './views/workbench/qualityCheck/detail.vue'),
            meta: {
                title: '采摘质量抽检'
            }
        },
        {
            path: '/workbench-qualityCheck-detail3',
            name: 'workbench-qualityCheck-detail3',
            component: () => import('./views/workbench/qualityCheck/detail3.vue'),
            meta: {
                title: '普通抽检详情'
            }
        },
        {
            path: '/workbench-qualityCheck-detail2',
            name: 'workbench-qualityCheck-detail2',
            component: () => import('./views/workbench/qualityCheck/detail2.vue'),
            meta: {
                title: '采摘质量抽检详情'
            }
        },
        {
            path: '/pickQuality-report',
            name: 'pickQuality-report',
            component: () => import('./views/pickQuality/report.vue'),
            meta: {
                title: '采摘质量抽检报表'
            }
        },
        {
            path: '/unionsale-market-list',
            name: 'unionsale-market-list',
            component: () => import('./views/unionsale/market/list.vue'),
            meta: {
                title: '销售出库',
                keepAlive: true
            }
        },
        {
            path: '/unionsale-market-cart',
            name: 'unionsale-market-cart',
            component: () => import('./views/unionsale/market/cart.vue'),
            meta: {
                title: '购物车结算'
            }
        },
        {
            path: '/vehicle-reach',
            name: 'vehicle-reach',
            component: () => import('./views/vehicle/reach/index.vue'),
            meta: {
                title: '车辆签到'
            }
        },
        {
            path: '/vehicle-reach2',
            name: 'vehicle-reach2',
            component: () => import('./views/vehicle/reach2/index.vue'),
            meta: {
                title: '车辆签到'
            }
        },
        {
            path: '/vehicle-reach-success',
            name: 'vehicle-reach-success',
            component: () => import('./views/vehicle/reach/success.vue'),
            meta: {
                title: '车辆签到成功'
            }
        },
        {
            path: '/vehicle-reach-information',
            name: 'vehicle-reach-information',
            component: () => import('./views/vehicle/reach/information.vue'),
            meta: {
                title: '流程单号信息'
            }
        },
        {
            path: '/vehicle-reach-out',
            name: 'vehicle-reach-out',
            component: () => import('./views/vehicle/reach/out.vue'),
            meta: {
                title: '车辆签退成功'
            }
        }, {
            path: '/vehicle-machiningCenter-list',
            name: 'vehicle-machiningCenter-list',
            component: () => import('./views/vehicle/machiningCenter/list.vue'),
            meta: {
                title: '车辆到离场装货管理'
            }
        },
        {
            path: '/vehicle-machiningCenter-detail',
            name: 'vehicle-machiningCenter-detail',
            component: () => import('./views/vehicle/machiningCenter/detail.vue'),
            meta: {
                title: '车辆到离场装货管理'
            }
        },
        {
            path: '/vehicle-machiningCenter-report',
            name: 'vehicle-machiningCenter-report',
            component: () => import('./views/vehicle/machiningCenter/report.vue'),
            meta: {
                title: '车辆到离场装货耗时报表'
            }
        }, {
            path: '/packReport-specification',
            name: 'packReport-specification',
            component: () => import('./views/packReport/specification.vue'),
            meta: {
                title: '同品不同规销售均价分析'
            }
        },
        {
            path: '/packReport-transitLoss',
            name: 'packReport-transitLoss',
            component: () => import('./views/packReport/transitLoss.vue'),
            meta: {
                title: '中转损耗'
            }
        },
        {
            path: '/workbench-ageRemind-index',
            name: 'workbench-ageRemind-index',
            component: () => import('./views/workbench/ageRemind/index.vue'),
            meta: {
                title: '库龄统计'
            }
        },
        {
            path: '/workbench-selectOutInvReport-index',
            name: 'workbench-selectOutInvReport-index',
            component: () => import('./views/workbench/selectOutInvReport/index.vue'),
            meta: {
                title: '先进先出核查'
            }
        },
        {
            path: '/clubsale-warehouseManagement-list',
            name: 'clubsale-warehouseManagement-list',
            component: () => import('./views/clubsale/warehouseManagement/list.vue'),
            meta: {
                title: '到货入库管理',//俱乐部客户
                keepAlive: true
            }
        },
        {
            path: '/clubsale-warehouseManagement-detail',
            name: 'clubsale-warehouseManagement-detail',
            component: () => import('./views/clubsale/warehouseManagement/detail.vue'),
            meta: {
                title: '到货入库查看'
            }
        },
        {
            path: '/clubsale-warehouseManagement-confirm',
            name: 'clubsale-warehouseManagement-confirm',
            component: () => import('./views/clubsale/warehouseManagement/confirm.vue'),
            meta: {
                title: '到货入库确认'
            }
        },
        {
            path: '/clubsale-warehouseManagement-add',
            name: 'clubsale-warehouseManagement-add',
            component: () => import('./views/clubsale/warehouseManagement/add.vue'),
            meta: {
                title: '到货入库'
            }
        },
        {
            path: '/clubsale-priceRequest-list',
            name: 'clubsale-priceRequest-list',
            component: () => import('./views/clubsale/priceRequest/list.vue'),
            meta: {
                title: '价格申请列表',
                keepAlive: true
            }
        },
        {
            path: '/clubsale-priceRequest-detail',
            name: 'clubsale-priceRequest-detail',
            component: () => import('./views/clubsale/priceRequest/detail.vue'),
            meta: {
                title: '价格申请单'
            }
        },
        {
            path: '/clubsale-inventory-list',
            name: 'clubsale-inventory-list',
            component: () => import('./views/clubsale/inventory/list.vue'),
            meta: {
                title: '实时库存',
                keepAlive: true
            }
        },
        {
            path: '/clubsale-uploadData-list',
            name: 'clubsale-uploadData-list',
            component: () => import('./views/clubsale/uploadData/list.vue'),
            meta: {
                title: '断价库存上报',
            }
        },
        {
            path: '/clubsale-uploadData-detail',
            name: 'clubsale-uploadData-detail',
            component: () => import('./views/clubsale/uploadData/detail.vue'),
            meta: {
                title: '填报页',
            }
        },
        {
            path: '/clubsale-inventory-detail',
            name: 'clubsale-inventory-detail',
            component: () => import('./views/clubsale/inventory/detail.vue'),
            meta: {
                title: '收发明细表'
            }
        },
        {
            path: '/clubsale-arrivalInfo-list',
            name: 'clubsale-arrivalInfo-list',
            component: () => import('./views/clubsale/arrivalInfo/list.vue'),
            meta: {
                title: '到货信息查询',
                keepAlive: true
            }
        },
        {
            path: '/clubsale-arrivalInfo-detail',
            name: 'clubsale-arrivalInfo-detail',
            component: () => import('./views/clubsale/arrivalInfo/detail.vue'),
            meta: {
                title: '到货详情'
            }
        },
        {
            path: '/clubsale-home',
            name: 'clubsale-home',
            component: () => import('./views/clubsale/home.vue'),
            meta: {
                title: '俱乐部销售管理'
            }
        },
        {
            path: '/clubsale-outbound-list',
            name: 'clubsale-outbound-list',
            component: () => import('./views/clubsale/outbound/list.vue'),
            meta: {
                title: '出库详情',
                keepAlive: true
            }
        },
        {
            path: '/clubsale-outbound-detail',
            name: 'clubsale-outbound-detail',
            component: () => import('./views/clubsale/outbound/detail.vue'),
            meta: {
                title: '果品出库明细'
            }
        },
        {
            path: '/clubsale-market-list',
            name: 'clubsale-market-list',
            component: () => import('./views/clubsale/market/list.vue'),
            meta: {
                title: '销售出库',
                keepAlive: true
            }
        },
        {
            path: '/clubsale-market-cart',
            name: 'clubsale-market-cart',
            component: () => import('./views/clubsale/market/cart.vue'),
            meta: {
                title: '购物车结算'
            }
        },
        {
            path: '/blueberry-arrival-sign',
            name: 'blueberry-arrival-sign',
            component: () => import('./views/blueberry/arrivalSign.vue'),
            meta: {
                title: '司机到货签到'
            }
        },
        {
            path: '/arrival-quality-list',
            name: 'arrival-quality-list',
            component: () => import('./views/workbench/arrivalQuality/index.vue'),
            meta: {
                title: '到货质检'
            }
        },
        {
            path: '/arrival-quality-detail',
            name: 'arrival-quality-detail',
            component: () => import('./views/workbench/arrivalQuality/detail.vue'),
            meta: {
                title: '到货质检'
            }
        },
        {
            path: '/saleOrderLinkTime-index',
            name: 'saleOrderLinkTime-index',
            component: () => import('./views/saleOrderLinkTime/index.vue'),
            meta: {
                title: '销售订单链路追踪',
                keepAlive: true
            }
        },
        {
            path: '/driving-trajectory',
            name: 'driving-trajectory',
            component: () => import('./views/saleOrderLinkTime/drivingTrajectory.vue'),
            meta: {
                title: '车辆行驶轨迹'
            }
        },
        {
            path: '/blueBerryLevel-list',
            name: 'blueBerryLevel-list',
            component: () => import('./views/blueBerryLevel/list.vue'),
            meta: {
                title: '蓝莓等级调整申请',
                keepAlive: true
            }
        },
        {
            path: '/blueBerryLevel-add',
            name: 'blueBerryLevel-add',
            component: () => import('./views/blueBerryLevel/add.vue'),
            meta: {
                title: '蓝莓等级调整申请'
            }
        },
        {
            path: '/workbench-inventory-detail',
            name: 'workbench-inventory-detail',
            component: () => import('./views/workbench/inventory/detail.vue'),
            meta: {
                title: '盘点'
            }
        },
        {
            path: '/workbench-inventory-view',
            name: 'workbench-inventory-view',
            component: () => import('./views/workbench/inventory/view.vue'),
            meta: {
                title: '盘点详情'
            }
        },
        {
            path: '/workbench-inventory-list',
            name: 'workbench-inventory-list',
            component: () => import('./views/workbench/inventory/list.vue'),
            meta: {
                title: '盘点列表',
                keepAlive: true
            }
        }, {
            path: '/workbench-rawFruitInventory-list',
            name: 'workbench-rawFruitInventory-list',
            component: () => import('./views/workbench/rawFruitInventory/list.vue'),
            meta: {
                title: '原果库存盘点列表',
                keepAlive: true
            }
        }, {
            path: '/workbench-rawFruitInventory-detail',
            name: 'workbench-rawFruitInventory-detail',
            component: () => import('./views/workbench/rawFruitInventory/detail.vue'),
            meta: {
                title: '盘点详情'
            }
        }, {
            path: '/workbench-productPackTimeRemind-index',
            name: 'workbench-productPackTimeRemind-index',
            component: () => import('./views/workbench/productPackTimeRemind/index.vue'),
            meta: {
                title: '成品包装时长'
            }
        },
        {
            path: '/workbench-levelDisclosure-index',
            name: 'workbench-levelDisclosure-index',
            component: () => import('./views/workbench/levelDisclosure/overAgedProducts.vue'),
        },
        {
            path: '/workbench-levelDisclosure-detail',
            name: 'workbench-levelDisclosure-detail',
            component: () => import('./views/workbench/levelDisclosure/detail.vue'),
        },
        {
            path: '/workbench-levelWraing-index',
            name: 'workbench-levelWraing-index',
            component: () => import('./views/workbench/levelWraing/index.vue'),
        },
        {
            path: '/blueberry-application-list',
            name: 'blueberry-application-list',
            component: () => import('./views/blueberry/application/list.vue'),
            meta: {
                keepAlive: true,
                title: '蓝莓果品申请列表'
            }
        },
        {
            path: '/blueberry-application-detail',
            name: 'blueberry-application-detail',
            component: () => import('./views/blueberry/application/detail.vue'),
            meta: {
                title: '蓝莓果品申请'
            }
        },
        {
            path: '/workbench-pickingTime-list',
            name: 'workbench-pickingTime-list',
            component: () => import('./views/workbench/pickingTime/list.vue'),
            meta: {
                title: '采摘时间确认'
            }
        },
        {
            path: '/workbench-pickingTask-list',
            name: 'workbench-pickingTask-list',
            component: () => import('./views/workbench/pickingTask/list.vue'),
            meta: {
                title: '领料列表',
                keepAlive: true,
            }
        },
        {
            path: '/workbench-pickingTask-pick',
            name: 'workbench-pickingTask-pick',
            component: () => import('./views/workbench/pickingTask/pick.vue'),
            meta: {
                title: '扫码领料'
            }
        },
        {
            path: '/workbench-pickingTask-back',
            name: 'workbench-pickingTask-back',
            component: () => import('./views/workbench/pickingTask/back.vue'),
            meta: {
                title: '扫码退料'
            }
        },
        {
            path: '/workbench-pickingTask-detail',
            name: 'workbench-pickingTask-detail',
            component: () => import('./views/workbench/pickingTask/detail.vue'),
            meta: {
                title: '领料详情'
            }
        },
        {
            path: '/skill-home',
            name: 'skill-home',
            component: () => import('./views/skill/home.vue'),
            meta: {
                title: '技术工落地甄选'
            }
        },
        {
            path: '/skill-fill',
            name: 'skill-fill',
            component: () => import('./views/skill/fill/add.vue'),
            meta: {
                title: '技术工填报'
            }
        },

        {
            path: '/skill-fill-gather',
            name: 'skill-fill-gather',
            component: () => import('./views/skill/fill/gather.vue'),
            meta: {
                title: '自查记录'
            }
        },
        {
            path: '/skill-fill-gather-new',
            name: 'skill-fill-gather-new',
            component: () => import('./views/skill/fill/gatherNew.vue'),
            meta: {
                title: '自查记录'
            }
        },
        {
            path: '/skill-fill-week',
            name: 'skill-fill-week',
            component: () => import('./views/skill/fill/list.vue'),
            meta: {
                title: '自查记录-周报'
            }
        },
        {
            path: '/skill-gather-week',
            name: 'skill-gather-week',
            component: () => import('./views/skill/fill/subareaList.vue'),
            meta: {
                title: '自查记录-周报'
            }
        },
        {
            path: '/skill-add-week',
            name: 'skill-add-week',
            component: () => import('./views/skill/fill/subareaAdd.vue'),
            meta: {
                title: '自查记录检查'
            }
        },
        {
            path: '/skill-add-week-new',
            name: 'skill-add-week-new',
            component: () => import('./views/skill/fill/subareaAddNew.vue'),
            meta: {
                title: '自查记录检查'
            }
        },

        // 日填报
        {
            path: '/skill-fill-day',
            name: 'skill-fill-day',
            component: () => import('./views/skill/fill/day/fillList.vue'),
            meta: {
                title: '自查记录-日报'
            }
        },
        {
            path: '/skill-record-day',
            name: 'skill-record-day',
            component: () => import('./views/skill/fill/day/fillAdd.vue'),
            meta: {
                title: '自查记录检查'
            }
        },
        // 技术工日报填报--新页面
        {
            path: '/skill-record-day-new',
            name: 'skill-record-day-new',
            component: () => import('./views/skill/fill/day/fillAddNew.vue'),
            meta: {
                title: '自查记录检查'
            }
        },
        {
            path: '/skill-gather-day',
            name: 'skill-gather-day',
            component: () => import('./views/skill/fill/day/checkList.vue'),
            meta: {
                title: '自查记录-日报'
            }
        },
        {
            path: '/skill-fill-flower',
            name: 'skill-fill-flower',
            component: () => import('./views/skill/fill/day/flowerList.vue'),
            meta: {
                title: '摘花日报'
            }
        },
        {
            path: '/skill-fill-flower-new',
            name: 'skill-fill-flower-new',
            component: () => import('./views/skill/fill/day/flowerListnew.vue'),
            meta: {
                title: '摘花日报'
            }
        },
        {
            path: '/skill-fill-flowerAdd',
            name: 'skill-fill-flowerAdd',
            component: () => import('./views/skill/fill/day/flowerAdd.vue'),
            meta: {
                title: '摘花日报'
            }
        },
        {
            path: '/skill-fill-flowerAdd-new',
            name: 'skill-fill-flowerAdd-new',
            component: () => import('./views/skill/fill/day/flowerAddnew.vue'),
            meta: {
                title: '摘花日报'
            }
        },
        {
            path: '/skill-check-day',
            name: 'skill-check-day',
            component: () => import('./views/skill/fill/day/checkAdd.vue'),
            meta: {
                title: '自查记录检查'
            }
        },
        //分场长日报填报--新页面
        {
            path: '/skill-check-day-new',
            name: 'skill-check-day-new',
            component: () => import('./views/skill/fill/day/checkAddNew.vue'),
            meta: {
                title: '自查记录检查'
            }
        },
        {
            path: '/skill-spot-check',
            name: 'skill-spot-check',
            component: () => import('./views/skill/spotCheck/list.vue'),
            meta: {
                title: '抽查记录'
            }
        },
        {
            path: '/skill-spot-check-detail',
            name: 'skill-spot-check-detail',
            component: () => import('./views/skill/spotCheck/detail.vue'),
            meta: {
                title: '抽查详情'
            }
        },
        {
            path: '/skill-tour-park',
            name: 'skill-tour-park',
            component: () => import('./views/skill/tourPark/list.vue'),
            meta: {
                title: '巡园管理'
            }
        },
        {
            path: '/skill-tour-park-detail',
            name: 'skill-tour-park-detail',
            component: () => import('./views/skill/tourPark/detail.vue'),
            meta: {
                title: '巡园详情'
            }
        },
        // 看板
        {
            path: '/skill-spectaculars-shed',//棚区
            name: 'skill-spectaculars-shed',
            component: () => import('./views/skill/spectaculars/shed.vue'),
            meta: {
                title: '技术工落地甄选系统-采摘管理'
            }
        },
        {
            path: '/skill-spectaculars-areaResponsibility',//责任区
            name: 'skill-spectaculars-areaResponsibility',
            component: () => import('./views/skill/spectaculars/areaResponsibility.vue'),
            meta: {
                title: '技术工落地甄选系统-采摘管理'
            }
        },
        {
            path: '/skill-spectaculars-delayDetail',//责任区
            name: 'skill-spectaculars-delayDetail',
            component: () => import('./views/skill/spectaculars/delayDetail.vue'),
            meta: {
                title: '技术工落地甄选系统-延采明细'
            }
        },
        {
            path: '/skill-spectaculars-areaPlant',//责任区
            name: 'skill-spectaculars-areaPlant',
            component: () => import('./views/skill/spectaculars/areaPlant.vue'),
            meta: {
                title: '技术工落地甄选系统-植保详情'
            }
        },
        {
            path: '/skill-spectaculars-areaPlant-detail',
            name: 'skill-spectaculars-areaPlant-detail',
            component: () => import('./views/skill/spectaculars/detailPlant.vue'),
            meta: {
                title: '技术工落地甄选系统-植保报告-到棚每周明细'
            }
        },
        {
            path: '/skill-spectaculars',
            name: 'skill-spectaculars',
            component: () => import('./views/skill/spectaculars/board.vue'),
            meta: {
                title: '技术工落地甄选系统-看板'
            }

        },
        // 看板详情
        {
            path: '/skill-spectaculars-detail',
            name: 'skill-spectaculars-detail',
            component: () => import('./views/skill/spectaculars/detail.vue'),
            meta: {
                title: '采摘管理'
            }
        },
        {
            path: '/plant-assistant',
            name: 'plant-assistant',
            component: () => import('./views/plantAssistant/index.vue'),
            meta: {
                title: '光筑植保助手'
            }
        },
        {
            path: '/pest-records',
            name: 'pest-records',
            component: () => import('./views/pestRecords/index.vue'),
            meta: {
                title: '病虫害防治作业记录'
            }
        },
        {
            path: '/plant-protection-create',
            name: 'plant-protection-create',
            component: () => import('./views/pestRecords/add.vue'),
            meta: {
                title: '病虫害防治作业记录'
            }
        },
        {
            path: '/honeybee-list',
            name: 'honeybee-list',
            component: () => import('./views/honeybee/list.vue'),
            meta: {
                title: '蜜蜂生命状态上报'
            }
        },
        {
            path: '/honeybee-add',
            name: 'honeybee-add',
            component: () => import('./views/honeybee/add.vue'),
            meta: {
                title: '蜜蜂生命状态上报'
            }
        },
        {
            path: '/honeybee-life-list',
            name: 'honeybee-life-list',
            component: () => import('./views/honeybee/lifeStatus.vue'),
            meta: {
                title: '蜜蜂生命状态列表'
            }
        },
        {
            path: '/honeybee-upload',
            name: 'honeybee-upload',
            component: () => import('./views/honeybee/honeybee-upload.vue'),
            meta: {
                title: '蜜蜂生命状态上报-图片上传'
            }
        },
        {
            path: '/scanning-instorage',
            name: 'scanning-instorage',
            component: () => import('./views/scanning/instorage.vue'),
            meta: {
                title: '成品果入库/码垛'
            }
        },
        {
            path: '/usercode-printer',
            name: 'usercode-printer',
            component: () => import('./views/chore/printer.vue'),
            meta: {
                title: '工人码打印'
            }
        },
        {
            path: '/full-link-quality-management',
            name: 'full-link-quality-management',
            component: () => import('./views/fullLinkQualityManagement/index.vue'),
            meta: {
                title: '全链路质量管理'
            }
        },
        {
            path: '/coupon',
            name: 'coupon',
            component: () => import('./views/coupon/index.vue'),
            meta: {
                title: '优惠券'
            }
        },

        {
            path: '/workbench-palletMonitor',
            name: 'workbench-palletMonitor',
            component: PalletMonitor,
            meta: { title: '拣货工单', keepAlive: false }
        },
        {
            path: '/workbench-palletMonitor-detail',
            name: 'workbench-palletMonitor-detail',
            component: PalletMonitorDetail,
            meta: { title: '工单详情' }
        },

        {
            path: '/scanning-sales-delivery',
            name: 'scanning-sales-delivery',
            component: () => import('./views/scanning/sales/delivery.vue'),
            meta: {
                title: '派送销售订单扫码出库'
            }
        },

        // 三级披露看板
        {
            path: '/thirdLevel-disclosureBoard',
            name: 'thirdLevelDisclosureBoard',
            component: () => import('./views/thirdLevelDisclosureBoard/index.vue'),
            meta: {
                title: '三级披露看板',
                keepAlive: true,
            }
        },
        {
            path: '/thirdLevel-disclosureBoard-detail',
            name: 'thirdLevelDisclosureBoardDetail',
            component: () => import('./views/thirdLevelDisclosureBoard/detail.vue'),
            meta: {
                title: '三级披露看板二级页面',
                keepAlive: true,
            }
        },
        {
            path: '/thirdLevel-disclosureBoard-report',
            name: 'thirdLevelDisclosureBoardReport',
            component: () => import('./views/thirdLevelDisclosureBoard/reportList.vue'),
            meta: {
                title: '三级披露原因与措施上报',
                keepAlive: true,
            }
        },
        {
            path: '/trace',
            name: 'trace',
            component: () => import('./views/trace/index.vue'),
            meta: {
                title: '果品追溯'
            }
        }, {
            path: '/scanning-stock',
            name: 'scanning-stock',
            component: () => import('./views/scanning/stock.vue'),
            meta: {
                title: '库位管理'
            }
        },
        {
            path: '/workbench-qualityCheck-process',
            name: 'workbench-qualityCheck-process',
            component: () => import('./views/workbench/qualityCheck/process.vue'),
            meta: {
                title: '过程质量管理'
            }
        },
        {
            path: '/workbench-otherMaterialRequisition-list',
            name: 'workbench-otherMaterialRequisition-list',
            component: () => import('./views/workbench/otherMaterialRequisition/index.vue'),
            meta: {
                title: '其他物料领用申请',
                keepAlive: false
            }
        },

        {
            path: '/workbench-otherMaterialRequisition-add',
            name: 'workbench-otherMaterialRequisition-add',
            component: () => import('./views/workbench/otherMaterialRequisition/add.vue'),
            meta: {
                title: '新建其他物料领用申请'
            }
        },
        {
            path: '/faceCollection',
            name: 'faceCollection',
            component: () => import('./views/FaceCollection.vue'),
            meta: {
                title: '人脸采集',
            }
        },

        {
            path: '/workbench-materialCheck-list',
            name: 'workbench-materialCheck-list',
            component: () => import('./views/workbench/materialCheck/list.vue'),
            meta: {
                title: '物料质量验收',
                keepAlive: true
            }
        },
        {
            path: '/workbench-materialCheck-add',
            name: 'workbench-materialCheck-add',
            component: () => import('./views/workbench/materialCheck/add.vue'),
            meta: {
                title: '新建物料质量验收'
            }
        },
        {
            path: '/workbench-materialCheck-add-material',
            name: 'workbench-materialCheck-add-material',
            component: () => import('./views/workbench/materialCheck/addMaterial.vue'),
            meta: {
                title: '物料质量验收-物料验收'
            }
        },
        {
            path: '/workbench-add-addPerson',
            name: 'workbench-add-addPerson',
            component: () => import('./views/addPerson/addPerson.vue'),
            meta: {
                title: '新增长工信息'
            }
        },
        {
            path: '/repackagingDiscrepancy',
            name: 'repackagingDiscrepancy',
            component: () => import('./views/repackagingDiscrepancy/index.vue'),
            meta: {
                title: '翻包差异'
            }
        },
        //翻包退货流程
        {
            path: '/return-process',
            name: 'return-process',
            component: () => import('./views/returnProcess/list.vue'),
            meta: {
                title: '退货流程审批'
            }
        },
        {
            path: '/return-process-applyForm',
            name: 'return-process-applyForm',
            component: () => import('./views/returnProcess/applyForm.vue'),
            meta: {
                title: '退货申请'
            }
        },
        // BI 数据分析
        {
            path: '/bi-home',
            name: 'bi-home',
            component: () => import('./views/bi/home.vue'),
            meta: {
                title: '爱莓庄BI系统'
            }
        },
        // 过熟核查-列表
        {
            path: '/overcooked-verification-list',
            name: 'overcooked-verification-list',
            component: () => import('./views/overcookedVerification/list.vue'),
            meta: {
                title: '过熟核查'
            }
        },
        // 过熟核查-列表详情
        {
            path: '/overcooked-verification-detail',
            name: 'overcooked-verification-detail',
            component: () => import('./views/overcookedVerification/detail.vue'),
            meta: {
                title: '过熟核查详情'
            }
        },

        //灌溉均匀度
        {
            path: '/skill-irrigationUniformity',
            name: 'skill-irrigationUniformity',
            component: () => import('./views/skill/irrigationUniformity/list.vue'),
            meta: {
                title: '灌溉均匀度'
            }
        },
        {
            path: '/skill-irrigationUniformity-add',
            name: 'skill-irrigationUniformity-add',
            component: () => import('./views/skill/irrigationUniformity/add.vue'),
            meta: {
                title: '灌溉均匀度'
            }
        },
        {
            path: '/skill-irrigationUniformity-addDetail',
            name: 'skill-irrigationUniformity-addDetail',
            component: () => import('./views/skill/irrigationUniformity/addDetail.vue'),
            meta: {
                title: '灌溉均匀度'
            }
        },
        {
            path: '/bi-newhome',
            name: 'bi-newhome',
            component: () => import('./views/biNew/home.vue'),
            meta: {
                title: '爱莓庄BI系统'
            }
        },
        {
            path: '/photo-submit',
            name: 'photo-submit',
            component: () => import('./views/photoSubmit/index.vue'),
            meta: {
                title: '提交照片'
            }
        },
        // 原料质检入库
        {
            path: '/workbench-materialInbound',
            name: 'workbench-materialInbound',
            component: () => import('./views/workbench/NKAservice/material-inbound/material-inbound.vue'),
            meta: {
                title: '质检入库记录'
            }
        },
        {
            path: '/workbench-materialInbound-form',
            name: 'workbench-materialInbound-form',
            component: () => import('./views/workbench/NKAservice/material-inbound/InboundForm.vue'),
            meta: {
                title: '质检入库'
            }
        },
        // 履约出库记录
        {
            path: '/workbench-fulfillmentOutbound',
            name: 'workbench-fulfillmentOutbound',
            component: () => import('./views/workbench/NKAservice/fulfillment-outbound/fulfillment-outbound.vue'),
            meta: {
                title: '履约出库记录'
            }
        },
        {
            path: '/workbench-fulfillmentOutbound-detail',
            name: 'workbench-fulfillmentOutbound-detail',
            component: () => import('./views/workbench/NKAservice/fulfillment-outbound/fulfillment-outbound-detail.vue'),
            meta: {
                title: '出库详情'
            }
        },
        {
            path: '/workbench-fulfillmentOutbound-pending',
            name: 'workbench-fulfillmentOutbound-pending',
            component: () => import('./views/workbench/NKAservice/fulfillment-outbound/fulfillment-outbound-pending.vue'),
            meta: {
                title: '待出库详情'
            }
        },
        {
            path: '/workbench-fulfillmentOutbound-scan',
            name: 'workbench-fulfillmentOutbound-scan',
            component: () => import('./views/workbench/NKAservice/fulfillment-outbound/fulfillment-outbound-scan.vue'),
            meta: {
                title: '扫码出库'
            }
        },
        {
            path: '/workbench-fulfillmentOutbound-return',
            name: 'workbench-fulfillmentOutbound-return',
            component: () => import('./views/workbench/NKAservice/fulfillment-outbound/fulfillment-outbound-return.vue'),
            meta: {
                title: '申请退货'
            }
        },
        {
            path: '/workbench-fulfillmentOutbound-scanReturn',
            name: 'workbench-fulfillmentOutbound-scanReturn',
            component: () => import('./views/workbench/NKAservice/fulfillment-outbound/fulfillment-outbound-scan-return.vue'),
            meta: {
                title: '扫码退货'
            }
        },
        {
            path: '/workbench-fulfillmentOutbound-approval',
            name: 'workbench-fulfillmentOutbound-approval',
            component: () => import('./views/workbench/NKAservice/fulfillment-outbound/fulfillment-outbound-approval.vue'),
            meta: {
                title: '损耗审批详情'
            }
        },
        // 包材入库
        {
            path: '/workbench-packagingInbound',
            name: 'workbench-packagingInbound',
            component: () => import('./views/workbench/NKAservice/packaging-inbound/packaging-inbound.vue'),
            meta: {
                title: '包材入库'
            }
        },
        {
            path: '/workbench-packagingInbound-form',
            name: 'workbench-packagingInbound-form',
            component: () => import('./views/workbench/NKAservice/packaging-inbound/PackagingInboundForm.vue'),
            meta: {
                title: '包材入库'
            }
        },
        // 生产领料
        {
            path: '/workbench-materialPickup',
            name: 'workbench-materialPickup',
            component: () => import('./views/workbench/NKAservice/material-pickup/material-pickup.vue'),
            meta: {
                title: '生产领料记录'
            }
        },
        {
            path: '/workbench-materialPickup-form',
            name: 'workbench-materialPickup-form',
            component: () => import('./views/workbench/NKAservice/material-pickup/MaterialPickupForm.vue'),
            meta: {
                title: '生产领料'
            }
        },
        {
            path: '/workbench-materialPickup-create',
            name: 'workbench-materialPickup-create',
            component: () => import('./views/workbench/NKAservice/material-pickup/MaterialPickupCreate.vue'),
            meta: {
                title: '领料申请'
            }
        },
        {
            path: '/workbench-materialPickup-detail',
            name: 'workbench-materialPickup-detail',
            component: () => import('./views/workbench/NKAservice/material-pickup/MaterialPickupDetail.vue'),
            meta: {
                title: '领料明细'
            }
        },
        {
            path: '/workbench-materialPickup-return',
            name: 'workbench-materialPickup-return',
            component: () => import('./views/workbench/NKAservice/material-pickup/MaterialReturn.vue'),
            meta: {
                title: '申请退料'
            }
        },
        {
            path: '/workbench-materialPickup-returnDetail',
            name: 'workbench-materialPickup-returnDetail',
            component: () => import('./views/workbench/NKAservice/material-pickup/MaterialReturnDetail.vue'),
            meta: {
                title: '退料详情'
            }
        },
        // 销售记录
        {
            path: '/workbench-salesRecord',
            name: 'workbench-salesRecord',
            component: () => import('./views/workbench/NKAservice/sales-record/sales-record.vue'),
            meta: {
                title: '销售记录'
            }
        },
        {
            path: '/workbench-salesRecord-detail',
            name: 'workbench-salesRecord-detail',
            component: () => import('./views/workbench/NKAservice/sales-record/sales-record-detail.vue'),
            meta: {
                title: '销售详情'
            }
        },
        // 成品入库记录
        {
            path: '/workbench-productInbound',
            name: 'workbench-productInbound',
            component: () => import('./views/workbench/NKAservice/product-inbound/product-inbound.vue'),
            meta: {
                title: '成品入库记录'
            }
        },
        {
            path: '/workbench-productInbound-create',
            name: 'workbench-productInbound-create',
            component: () => import('./views/workbench/NKAservice/product-inbound/ProductInboundCreate.vue'),
            meta: {
                title: '扫码入库'
            }
        },
        {
            path: '/workbench-productInbound-detail',
            name: 'workbench-productInbound-detail',
            component: () => import('./views/workbench/NKAservice/product-inbound/ProductInboundDetail.vue'),
            meta: {
                title: '入库详情'
            }
        },
        // 履约订单
        {
            path: '/workbench-fulfillmentOrder',
            name: 'workbench-fulfillmentOrder',
            component: () => import('./views/workbench/NKAservice/fulfillment-order/fulfillment-order.vue'),
            meta: {
                title: '履约订单'
            }
        },
        {
            path: '/workbench-fulfillmentOrder-create',
            name: 'workbench-fulfillmentOrder-create',
            component: () => import('./views/workbench/NKAservice/fulfillment-order/FulfillmentOrderCreate.vue'),
            meta: {
                title: '新建履约订单'
            }
        },
        {
            path: '/openMiniProgram',
            name: 'openMiniProgram',
            component: () => import('./views/OpenMiniProgram.vue'),
            meta: {
                title: '打开小程序'
            }
        },
    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
})